<template>
  <section id="gold-trader" v-if="$route.name == 'miniapp-market-gold-trader'">
    <PriceLabel types="trader" :price="getGoldSpotThaiRealtimeLastPrice" />
    <ToggleLabel @toggle-average="value => toggleAverage = value" :price="getGoldTraderPresent"/>
    <GoldSpotThaiGraph :is-gold-trader="toggleAverage" goldSpotId="gold-spot-thai-graph-d3-line" />
  </section>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  data() {
    return {
      goldType: "gold",
      shortCode: "trader_bar",
      toggleAverage: true
    };
  },
  components: {
    GoldSpotThaiGraph: () => import("../../../../../components/miniapp/gold/GoldSpotThaiGraph"),
    PriceLabel: () => import("@/components/miniapp/global/PriceLabel"),
    ToggleLabel: () => import("@/components/miniapp/global/ToggleLabel")
  },
  computed: {
    ...mapGetters("gold", ["getGoldSpotThaiRealtimeLastPrice", "getGoldTraderPresent"]),
  },
  methods: {
    chartModalTV(short_code) {
      let gold_type = short_code == "gold_spot" ? "gold_spot" : "gold"
      this.$router.push({
        name: "miniapp-tradingview",
        query: { name: short_code, type: gold_type }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
#gold-trader{
  margin-top: 16px;
} 
</style>